function joinSegments (segments, delimiter) {
  delimiter = delimiter || '/'
  var result = ''

  if (segments && Array.isArray(segments)) {
    segments.forEach(function (element, index, array) {
      var segment = []

      if (index === array.length - 1) {
        segment = [element]
      } else {
        segment = element.delimiter ? [element.value, element.delimiter] : [element, delimiter]
      }

      result = result.concat(segment.join(''))
    })
  }

  return result
}

function prepareHostname (hostname) {
  var result = ''

  if (hostname) {
    hostname = hostname.trim()

    if (hostname.slice(-1) === '/') {
      hostname = hostname.slice(0, -1)
    }

    result = (hostname.indexOf('http://') > -1 || hostname.indexOf('https://') > -1) ? hostname : '//' + hostname
  }

  return result
}

function convertUrlToClasses (path) {
  var result = ''
  if (path && typeof path === 'string') {
    result = path
    .split('/')
    .filter(function (item) {
      return Boolean(item)
    })
    .map(function (item) {
      return 'url-' + item
    })

    // result.unshift('url-state-' + to.name)
    result = result.join(' ')
  }

  return result
}

export default {
  joinSegments,
  prepareHostname,
  convertUrlToClasses
}



// WEBPACK FOOTER //
// ./src/library/core/url.js